const fileIsDownloaded = fileOverview => !!(fileOverview && fileOverview.fetched)

export default fileIsDownloaded